import React from "react";
import { Modal, Button } from "react-bootstrap";

const InvoiceSendEmailModal = ({
  show,
  onClose,
  onSend,
  sending = false,
  clientName = "",
  clientEmail = "",
  invoiceNo = "",
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="md"
      centered
      className="email-model"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <div className="text-center col-11 font-f-sans white w-100">
          Send Invoice to Client
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3" style={{ fontSize: 14, color: "#374151" }}>
          Send invoice <strong>INV-{invoiceNo}</strong> to{" "}
          <strong>{clientName || "the client"}</strong>?
        </p>
        <div className="mb-2">
          <label className="profile-label">Recipient Email</label>
          <input
            type="email"
            className="form-control"
            value={clientEmail || ""}
            readOnly
            disabled
          />
        </div>
        <p className="small text-muted mb-0">
          A PDF copy of the invoice preview (same layout as on screen) will be
          attached to the email sent to the client.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose} disabled={sending}>
          Cancel
        </Button>
        <Button variant="success" onClick={onSend} disabled={sending}>
          {sending ? "Sending..." : "Send Invoice"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceSendEmailModal;
